import ReviewPage from 'components/ReviewPage'

export default ReviewPage
